const ChangeColorIcon = ({ onClick }) => {
  return (
    <svg
      onClick={onClick}
      width="53.621"
      height="38"
      viewBox="0 0 53.621 38"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs></defs>
      <g
        id="Raggruppa_1190"
        data-name="Raggruppa 1190"
        transform="translate(-35.379 -573)"
      >
        <g
          id="Raggruppa_926"
          data-name="Raggruppa 926"
          transform="translate(106.94 1237) rotate(180)"
        >
          <path
            id="Tracciato_258"
            data-name="Tracciato 258"
            d="M0,0,4.24,4.241,0,8.482"
            transform="translate(64.5 650.741) rotate(180)"
            stroke-linecap="round"
            stroke-width="1.5"
            fill="none"
            style={{ stroke: "rgb(48, 49, 48)" }}
          ></path>
          <path
            id="Tracciato_259"
            data-name="Tracciato 259"
            d="M0,0,4.24,4.241,0,8.482"
            transform="translate(70.5 650.741) rotate(180)"
            stroke-linecap="round"
            stroke-width="1.5"
            fill="none"
            style={{ stroke: "rgb(48, 49, 48)" }}
          ></path>
        </g>
        <g
          id="Raggruppa_1040"
          data-name="Raggruppa 1040"
          transform="matrix(1.602467, 0, 0, 1.723964, -51.552286, -329.486368)"
        >
          <g
            transform="matrix(-0.001494, 0, 0, -0.001243, 88.7027, 541.286332)"
            fill="#303130"
            stroke="none"
          >
            <path
              d="M6135 11194 c-1192 -76 -2249 -543 -3088 -1364 -762 -745 -1247
                    -1695 -1396 -2737 -38 -261 -46 -384 -45 -698 0 -443 38 -760 139 -1165 89
                    -351 181 -602 350 -945 185 -376 364 -652 636 -980 118 -143 461 -481 616
                    -608 711 -581 1539 -940 2440 -1057 312 -41 690 -50 798 -20 182 51 328 143
                    434 275 130 161 191 350 177 555 -12 197 -68 325 -219 505 -67 80 -137 216
                    -163 320 -25 96 -25 285 0 380 63 243 225 437 449 540 149 68 141 67 887 75
                    371 4 686 10 700 13 14 4 70 13 125 22 536 84 1050 351 1447 752 324 327 539
                    688 672 1133 108 360 133 810 70 1265 -186 1335 -1066 2512 -2379 3180 -582
                    296 -1185 471 -1865 540 -147 15 -654 27 -785 19z m-840 -1094 c272 -86 474
                    -296 547 -568 28 -109 28 -287 -1 -397 -74 -281 -295 -502 -576 -576 -114 -30
                    -280 -30 -394 0 -277 73 -484 271 -571 546 -28 90 -38 267 -20 368 54 313 301
                    570 614 642 94 22 312 14 401 -15z m2603 15 c315 -66 567 -325 622 -642 18
                    -101 8 -278 -20 -368 -87 -275 -294 -473 -571 -546 -114 -30 -280 -30 -394 0
                    -281 74 -502 295 -576 576 -30 112 -30 289 0 399 79 297 323 527 622 585 71
                    14 242 12 317 -4z m-4308 -2126 c177 -28 313 -100 445 -233 133 -134 200 -272
                    225 -464 32 -245 -61 -496 -247 -673 -98 -94 -201 -151 -340 -191 -102 -29
                    -304 -31 -403 -4 -362 99 -600 408 -600 775 0 165 42 311 127 439 175 263 486
                    401 793 351z m5958 -19 c348 -98 582 -408 582 -770 0 -165 -39 -297 -126 -433
                    -250 -387 -770 -483 -1146 -210 -122 88 -238 250 -286 399 -88 271 -20 577
                    175 785 123 130 271 213 438 245 96 19 269 11 363 -16z"
              style={{ stroke: "rgb(48, 49, 48)" }}
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

ChangeColorIcon.defaultProps = {
  onCLick: () => {},
};

export { ChangeColorIcon };
